import joinClassNames from '../primitives/joinClassNames.js'

/**
 * Account / admin settings form shell (`.account-prefs-form-card`).
 */
export default function SettingsFormCard({
  title,
  children,
  footer,
  footerAriaLabel = 'Settings actions',
  id,
  className = '',
  bodyClassName = '',
}) {
  return (
    <div className={joinClassNames('account-prefs-form-card', className)} id={id}>
      {title != null && (
        <header className="account-prefs-form-card-header">
          <div className="account-prefs-form-card-title">{title}</div>
        </header>
      )}
      <div className={joinClassNames('account-prefs-form-card-body', bodyClassName)}>
        {children}
      </div>
      {footer != null && (
        <div className="account-prefs-form-card-footer" role="toolbar" aria-label={footerAriaLabel}>
          {footer}
        </div>
      )}
    </div>
  )
}
